import { useEffect }                from 'react';
import { useSnackbar, VariantType } from 'notistack';

export const Notification: any = (): null => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(
    (): void => {
      Notification.enqueueSnackbar = (message: string, variant: VariantType): void => {
        enqueueSnackbar(message, { variant });
      };
    },
    [enqueueSnackbar],
  );

  useEffect(
    (): void => {
      Notification.closeSnackbar = (): void => {
        closeSnackbar();
      };
    },
    [closeSnackbar],
  );

  return null;
};
